import {Button, Flex, Form, Input, Typography} from "antd";
import TextArea from "antd/es/input/TextArea";

import "./RequestModal.css";
import {useState} from "react";
import {productRequest} from "../../utils/APIUtils";

const {  Text } = Typography;

const RequestModal = ( {close, alert} ) => {

    const [state, setState] = useState({
        company: null,
        phone: null,
        email: null,
        description: null,
    });

    const clearState = () => {
        setState({
            company: null,
            phone: null,
            email: null,
            description: null,
        })
    }

    const sendRequest = () => {
        if (validate()){
            alert("success", "Заявка успешно отправлена")
            productRequest(state).then(r => console.log(r));
            clearState();
            close();
        }
    }

    const validate = () => {
        if (!state.company || state.company === ""){
            alert("error", <>Поле <Text strong> Организация </Text> должно быть заполнено! </>);
            return false;
        }

        if (!state.phone || state.phone === ""){
            alert("error", <>Поле <Text strong> Номер телефона </Text> должно быть заполнено! </>);
            return false;
        }
        if (!state.email || state.email === ""){
            alert("error", <>Поле <Text strong> Адрес эл. почты </Text> должно быть заполнено! </>);
            return false;
        }

        return true;
    }


    return(
        <div className={"request-modal"}>
            <Form
                style={{height:'100%'}}
                layout={"vertical"}
                size={"large"}
            >
                <Form.Item required={true} label={"Организация"}>
                    <Input
                        placeholder={"Организация или \" Частное лицо\" "}
                        value={state.company}
                        onChange={(e) => setState({ ...state, company: e.target.value })}
                    />
                </Form.Item>
                <Form.Item required={true} label={"Номер телефона"}>
                    <Input
                        placeholder={"+7 (999)-999-99-99"}
                        value={state.phone}
                        onChange={(e) => setState({ ...state, phone: e.target.value })}
                    />
                </Form.Item>
                <Form.Item required={true} label={"Адрес эл. почты"}>
                    <Input
                        placeholder={"company@mail.ru"}
                        value={state.email}
                        onChange={(e) => setState({ ...state, email: e.target.value })}
                    />
                </Form.Item>
                <Form.Item label={"Доп. информация"}>
                    <TextArea
                        style={{minHeight: "150px"}}
                        size={"large"}
                        value={state.description}
                        onChange={(e) => setState({ ...state, description: e.target.value })}
                    />
                </Form.Item>
            </Form>
            <Flex justify={"flex-end"} style={{width:'100%', marginTop: "15px"}} gap={"small"}>
                <Button
                    onClick={() => {
                        clearState();
                        close();
                    }}
                >
                    Отменить
                </Button>
                <Button
                    color="default"
                    variant="solid"
                    onClick={() => sendRequest()}
                >
                    Отправить
                </Button>
            </Flex>
        </div>
    )

}

export default RequestModal;